//ADMIN PERSONAL INFO
export const ADMIN_PERSONAL_INFO_REQUEST = "ADMIN_PERSONAL_INFO_REQUEST";
export const ADMIN_PERSONAL_INFO_SUCCESS = "ADMIN_PERSONAL_INFO_SUCCESS";
export const ADMIN_PERSONAL_INFO_FAIL = "ADMIN_PERSONAL_INFO_FAIL";

//GET ADMIN PERSONAL INFO
export const GET_ADMIN_PERSONAL_INFO_REQUEST =
  "GET_ADMIN_PERSONAL_INFO_REQUEST";
export const GET_ADMIN_PERSONAL_INFO_SUCCESS =
  "GET_ADMIN_PERSONAL_INFO_SUCCESS";
export const GET_ADMIN_PERSONAL_INFO_FAIL = "GET_USER_PERSONAL_INFO_FAIL";
